import { GetterTree } from 'vuex'
import { VacationApplication, VacationApplicationsState } from '@/store/applications/vacations/types'
import { RootState } from '@/store/types'

const getters : GetterTree<VacationApplicationsState, RootState> = {
  /**
   * 申請IDを元に休暇申請情報を取得
   * @param {string} applicationId 申請ID
   * @return {VacationApplication|null} 申請情報
   */
  findVacationApplicationById: (state) => (applicationId: string): VacationApplication|null => {
    return state.applications.find((app: VacationApplication) => app.id === applicationId) || null
  },
}

export default getters
